import React, { Fragment, useState, useEffect, useRef } from 'react'
import {t} from 'i18next'
import { useNavigate } from 'react-router-dom'
import { Container, Nav, NavItem, NavLink, Card, CardBody, Button, TabContent, TabPane } from 'reactstrap'
import { useRecoilValue } from 'recoil'
import axios from 'axios'

import env from '../../env/src_config'
import { headersState, tokenState } from '../../recoil/recoil';
import { axiosError } from '../../helpers/response'
import { isNull } from '../../izUtils'
import { transformer } from '../../helpers/fields'
import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb';
import UsersComponent from '../../components/users/UsersComponent'
import DictionaryInfoButton from '../../components/dictionary/DictionaryInfoButton';

const Users = () => {
    const Navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const tokenData = useRecoilValue(tokenState);
    const [users, setUsers] = useState(null);
    const [filters, setFilters] = useState(null);

    const callingBE = useRef(false);

    const lsFilterName = 'AKODA.userFilter';

    useEffect(() => {
        const lsFilter = JSON.parse(localStorage.getItem(lsFilterName));
        let filter = isNull(lsFilter) ? {} : lsFilter;
        getUsers(filter);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getUsers = (passedFilters, redirect = false) => {
        callingBE.current = true;

        const keys = Object.keys(passedFilters);
        let payload = { filters: {} };

        for (let i = 0; i < keys.length; i++) {
            if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                payload.filters[keys[i]] = passedFilters[keys[i]].value;
            } else {
                payload.filters[keys[i]] = "";
            }
        }

        axios.post(env.api + '/api/user/list', payload, {headers}).then(response => {
            if (!isNull(response.data.data)) {
                setUsers(response.data.data);
                if (!isNull(response.data.filters)) {
                    setFilters(transformer(response.data.filters));
                    localStorage.setItem(lsFilterName, JSON.stringify(transformer(response.data.filters)))
                }

                if (redirect) Navigate('/users');

            }

            callingBE.current = false;
        }).catch(error => {
            callingBE.current = false;
            axiosError(error, Navigate);
        });
    }

    const handleTab = (tab) => {
        if (callingBE.current) return;
        let clonedFilters = {...filters};
        clonedFilters.tabs.value = tab.id;
        getUsers(clonedFilters, true);
    }

    const clearData = () => {
        localStorage.removeItem(lsFilterName)
        getUsers({});
    }

    return (
        <Fragment>
            <Breadcrumbs parent="" title={t('breadcrumb.users')}/>
            <Container fluid={true}>
                {tokenData.parsedToken.type === 'admin' &&
                    <Card>
                        <CardBody className='p-3'>
                            {filters &&
                                <Nav className="nav-primary nav-pills">
                                    {filters.tabs.values.map((tab, index) => {
                                        return (
                                            <NavItem key={index}>
                                                <NavLink className={`d-flex align-items-center ${filters.tabs.value === tab.id ? 'active' : ''}`} onClick={() => handleTab(tab)}>
                                                    <i className={"fa fa-" + tab.id}></i>
                                                    {t(tab.title)}
                                                    {tab.id === 'requests' && <DictionaryInfoButton code="users.list.requests" id="users.list.requests" />}
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })}
                                </Nav>
                            }
                        </CardBody>
                    </Card>
                }
                <TabContent activeTab={true}>
                    <TabPane className="fade show" tabId={true}>
                        <UsersComponent users={users} filters={filters} lsFilterName={lsFilterName} clearData={clearData} getUsers={getUsers} />
                    </TabPane>
                </TabContent>
                <hr/>
                <div className='d-flex flex-wrap justify-content-between mb-4'>
                    <div>
                        <Button color="danger" className="mt-2 me-2" onClick={() => Navigate('/')}>{t('back')}</Button>
                    </div>
                </div>
            </Container>
        </Fragment>
    )
}

export default Users